import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import { Wizard, Modal } from '@yuhuinc/ui-library/';
import LeaseDetailsPage from './components/lease_creator_v2/lease_details_page/LeaseDetailsPage';
import LeasePricingPage from './components/lease_creator_v2/lease_pricing_page/LeasePricingPage';
import LeaseIncentivesPage from './components/lease_creator_v2/lease_incentives_page/LeaseIncentivesPage';
import LeaseDocumentTemplatesPage from './components/lease_creator_v2/lease_document_templates_page/LeaseDocumentTemplatesPage';
import AdditionalInformationPage from './components/lease_creator_v2/additional_information_page/AdditionalInformationPage';
import LeaseServiceAndUtilitiesPage from './components/lease_creator_v2/lease_service_and_utilities_page/LeaseServiceAndUtilitiesPage';
import LeaseSummaryPage from './components/lease_creator_v2/lease_summary_page/LeaseSummaryPage';
import LeasePreviewPage from './components/lease_creator_v2/lease_preview_page/LeasePreviewPage';

import { featureEnabled } from 'helpers/ToggleBot';
import { getTranslatedString } from 'helpers/i18n';
import { leaseCreatorColors } from 'helpers/ColorHelper';
import { LEASE_DETAILS_PAGE, LEASE_PREVIEW_PAGE } from 'helpers/DocumentTemplateHelper';

import { saveInProgressLeaseDetails } from 'actions/landlordApplicationsActions';
import {
  storeLatestLeaseReview,
  storeLeaseReviews,
} from './components/lease_creator_v2/store/actions';

const StyledWizardContainer = styled.div`
  padding-top: 53px;
  overflow-y: scroll;
  height: 100%;
  padding-top: 53px;
  padding-bottom: 53px;
  overflow-y: scroll;
  background-color: ${leaseCreatorColors.WIZARD_BACKGROUND};
`;

const PENDING_LEASE_APPROVAL = 'pending_lease_approval';

const LeaseCreatorUIWizard = ({
  saveInProgressLeaseDetails,
  leaseDetails,
  application,
  storeLatestLeaseReview,
  storeLeaseReviews,
}) => {
  const [leaseFormValues, setLeaseFormValues] = useState({});
  const [finishStatus, setfinishStatus] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [wizardStartAt, setWizardStartAt] = useState(LEASE_DETAILS_PAGE);
  const [leaseCanBeSent, setLeaseCanBeSent] = useState(false);
  const [restartWizard, setRestartWizard] = useState(false);
  const [checkWizardStartPage, setCheckWizardStartPage] = useState(false);

  useEffect(() => {
    if (!featureEnabled('custom_lease_creator') || isEmpty(leaseDetails)) {
      browserHistory.push('/companies/applications'); // push to applications table
      return;
    }
    if (!isEmpty(leaseDetails)) {
      setLeaseFormValues(leaseDetails.draft_lease_data);
    }
  }, [leaseDetails]);

  useEffect(() => {
    if (!checkWizardStartPage) {
      let latestReview = {};
      if (!isEmpty(leaseDetails) && !isEmpty(leaseDetails.lease_reviews)) {
        storeLeaseReviews(leaseDetails.lease_reviews);
        const latestLeaseReviewStore = storeLatestLeaseReview(
          leaseDetails.lease_reviews[leaseDetails.lease_reviews.length - 1]
        );
        latestReview = latestLeaseReviewStore.latestLeaseReview;
      } else {
        storeLeaseReviews([]);
        storeLatestLeaseReview({});
      }

      if (
        (!isEmpty(application) &&
          application.status === PENDING_LEASE_APPROVAL &&
          application.can_approve_application) ||
        ['approved', 'rejected'].includes(latestReview.status)
      ) {
        setWizardStartAt(LEASE_PREVIEW_PAGE);
        setRestartWizard(true);
        if (latestReview.status === 'approved') {
          setLeaseCanBeSent(true);
        }
      }
      setCheckWizardStartPage(true);
    }
  }, [
    application,
    leaseDetails,
    storeLatestLeaseReview,
    storeLeaseReviews,
    wizardStartAt,
    checkWizardStartPage,
  ]);

  const showModalPopup = () => {
    setShowModal(true);
  };
  const hideModalPopup = () => {
    setShowModal(false);
  };

  const saveDraftLease = (values) => {
    saveInProgressLeaseDetails(leaseDetails.lease_id, { ...leaseFormValues, ...values });
  };

  const goBackToApplicationsPage = () => {
    browserHistory.push('/companies/applications');
  };

  useEffect(() => {
    const onBackButtonEvent = (e) => {
      e.preventDefault();
      if (!finishStatus) {
        if (
          window.confirm(
            getTranslatedString('landlordPortal.leaseCreatorV2.uiWizard.changesWillNotBeSaved')
          )
        ) {
          setfinishStatus(true);
          browserHistory.goBack();
        } else {
          window.history.pushState(null, null, window.location.pathname);
          setfinishStatus(false);
        }
      }
    };

    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener('popstate', onBackButtonEvent);

    window.onbeforeunload = function () {
      return false;
    };

    return () => {
      window.removeEventListener('popstate', onBackButtonEvent);
      window.onbeforeunload = function () {
        return undefined;
      };
    };
  }, [finishStatus]);

  const pages = [
    {
      component: (props) => (
        <LeaseDetailsPage
          leaseDetails={leaseDetails}
          setLeaseFormValues={setLeaseFormValues}
          leaseFormValues={leaseFormValues}
          handleCancellation={showModalPopup}
          saveDraftLease={saveDraftLease}
          {...props}
        />
      ),
    },
    {
      component: (props) => (
        <LeasePricingPage
          leaseDetails={leaseDetails}
          setLeaseFormValues={setLeaseFormValues}
          leaseFormValues={leaseFormValues}
          saveDraftLease={saveDraftLease}
          handleCancellation={showModalPopup}
          {...props}
        />
      ),
    },
    {
      component: (props) => (
        <LeaseIncentivesPage
          leaseDetails={leaseDetails}
          setLeaseFormValues={setLeaseFormValues}
          leaseFormValues={leaseFormValues}
          saveDraftLease={saveDraftLease}
          handleCancellation={showModalPopup}
          {...props}
        />
      ),
    },
    {
      component: (props) => (
        <LeaseServiceAndUtilitiesPage
          leaseDetails={leaseDetails}
          setLeaseFormValues={setLeaseFormValues}
          leaseFormValues={leaseFormValues}
          saveDraftLease={saveDraftLease}
          handleCancellation={showModalPopup}
          {...props}
        />
      ),
    },
    {
      component: (props) => (
        <LeaseDocumentTemplatesPage
          leaseDetails={leaseDetails}
          setLeaseFormValues={setLeaseFormValues}
          saveDraftLease={saveDraftLease}
          leaseFormValues={leaseFormValues}
          handleCancellation={showModalPopup}
          {...props}
        />
      ),
    },
    {
      component: (props) => (
        <AdditionalInformationPage
          leaseDetails={leaseDetails}
          setLeaseFormValues={setLeaseFormValues}
          leaseFormValues={leaseFormValues}
          saveDraftLease={saveDraftLease}
          handleCancellation={showModalPopup}
          {...props}
        />
      ),
    },
    {
      component: (props) => (
        <LeaseSummaryPage
          leaseDetails={leaseDetails}
          setLeaseFormValues={setLeaseFormValues}
          leaseFormValues={leaseFormValues}
          saveDraftLease={saveDraftLease}
          handleCancellation={showModalPopup}
          {...props}
        />
      ),
    },
    {
      component: (props) => (
        <LeasePreviewPage
          leaseDetails={leaseDetails}
          setLeaseFormValues={setLeaseFormValues}
          leaseFormValues={leaseFormValues}
          saveDraftLease={saveDraftLease}
          handleCancellation={showModalPopup}
          leaseCanBeSent={leaseCanBeSent}
          restartWizard={restartWizard}
          {...props}
        />
      ),
    },
  ];

  return (
    <StyledWizardContainer>
      {showModal && (
        <Modal
          headerContent={getTranslatedString(
            'landlordPortal.leaseCreatorV2.uiWizard.thisPageIsIncomplete'
          )}
          bodyContent={getTranslatedString(
            'landlordPortal.leaseCreatorV2.uiWizard.onlyCompletedPagesAreSaved'
          )}
          warningModal={true}
          YesButtonContent={getTranslatedString(
            'landlordPortal.leaseCreatorV2.uiWizard.continueEditing'
          )}
          NoButtonContent={getTranslatedString(
            'landlordPortal.leaseCreatorV2.uiWizard.exitLeaseCreator'
          )}
          isMobile={false}
          NoButtonAction={goBackToApplicationsPage}
          YesButtonAction={hideModalPopup}
        />
      )}
      <div>{!isEmpty(leaseDetails) && <Wizard pages={pages} startAtPage={wizardStartAt} />}</div>
    </StyledWizardContainer>
  );
};

const mapStoreToProps = (store) => ({
  properties: store.landlordProperties.properties,
  leaseDetails: store.landlordApplications.leaseDetails,
  application: store.landlordApplications.application,
});

const mapDispatchToProps = {
  saveInProgressLeaseDetails,
  storeLatestLeaseReview,
  storeLeaseReviews,
};

export default connect(mapStoreToProps, mapDispatchToProps)(LeaseCreatorUIWizard);
